import type { CheckoutConfig } from '#types/config/pages/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  showLegalBeforePayment: true
} satisfies RecursivePartial<CheckoutConfig>
